import React from 'react';
import {Box, Grid} from "@mui/material";
import BookingLoadingSkeleton from '../BookingCard/BookingLoadingSkeleton';
import SupplierBookingCardList from './supplier/SupplierBookingCardList';
import BuyerBookingCardList from './buyer/BuyerBookingCardList';
import TextBox from '../bookingsOverview/TextBox';
import { AccountType } from '../constants/securspace-constants';
import { BookingStatusGroupVerbiage } from './data';
import Pagination from "../deprecatedUikit/Pagination/Pagination";


const BookingTab = (props) => {
  const {
    bookings,
    loading,
    page,
    setPage,
    count,
    status,
    rowsPerPage,
    setRowsPerPage,
    userIsAdmin,
    handleSelectAdjustBooking,
    handleUpdatePendingBooking,
    handleEndBooking,
    handleShowCancelBookingRequestModal,
    handleMakePayment,
    handleShowPaymentModal,
    accountType
  } = props;


  const infoBoxTitle = () => {
    return BookingStatusGroupVerbiage[status]?.description || "";
  }

  const shouldResetPage = (requestedPage, rowsPerPage, totalBookings) => {
    const newPageCount = Math.ceil(totalBookings / rowsPerPage);
    return requestedPage > 0 ? newPageCount < requestedPage + 1 : false;
  };

  const handleRowsPerPageChange = ({target}) => {
    if (shouldResetPage(page, target.value, count)) {
      setPage(0);
    }
    setRowsPerPage(target.value);
  }

  const handlePageChange = (_, page) => {
    setPage(page)
  }

  return (
    <Box>
      {
        loading ?
          <BookingLoadingSkeleton/>
          :
          <Box>
            <TextBox title={infoBoxTitle()}/>
            {accountType === AccountType.SUPPLIER ?
              <SupplierBookingCardList
                bookings={bookings || []}
                userIsAdmin={userIsAdmin}
                handleSelectAdjustBooking={handleSelectAdjustBooking}
                handleUpdatePendingBooking={handleUpdatePendingBooking}
              />
            :
              <BuyerBookingCardList
                bookings={bookings || []}
                onShowCancelBookingRequestModal={handleShowCancelBookingRequestModal}
                onEnd={handleEndBooking}
                onUpdate={handleSelectAdjustBooking}
                onMakePayment={handleMakePayment}
                onShowPaymentModal={handleShowPaymentModal}
              />
            }
          </Box>
      }
      {
        bookings?.length > 0 && <Grid item>
          <Pagination
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            variant="tablePagination"
          />
        </Grid>
      }
    </Box>
  );
};

export default BookingTab;
